module.exports = __webpack_public_path__ + "img/loading.c9710e4c.svg";